export default {
  description: '{{name}} em {{city}}. Menu oficial. Poupe dinheiro e encomende aqui online.',
};
